export default function countPercent(complete, failed) {
  return ((failed && (failed / complete * 100)) || 0).toFixed(2)
}



// WEBPACK FOOTER //
// ./src/components/Report/defectivness/countPercent.js